import Table from "components/Table";
import React, { useMemo } from "react";
import { getPayrollsColumns } from "./columns";

const data = [];

const PayrollsTable = () => {
  const columns = useMemo(() => {
    return getPayrollsColumns();
  }, []);
  return (
    <div>
      <Table
        headers={columns}
        data={data}
        showPagination={false}
        containerStyle={{
          borderRadius: "0px",
          border: "none",
        }}
      />
    </div>
  );
};

export default PayrollsTable;
